import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "searchcontent flex-n fac" }
const _hoisted_2 = { class: "flex-n fac flex-1" }
const _hoisted_3 = { class: "flex-n fac fjb card-top" }
const _hoisted_4 = { class: "name flex-n fac" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "flex-n fac card-middle" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "right-content flex-1" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "text flex-n fac" }
const _hoisted_11 = { style: {"margin-left":"0.5rem"} }
const _hoisted_12 = { class: "btn-area flex-n fje" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

import {ref, onMounted} from 'vue';
import {useRouter} from 'vue-router'
import personobituaryApi from "@/utils/Api/PersonObituary";


export default /*@__PURE__*/_defineComponent({
  __name: 'memoriallist',
  setup(__props) {

const userName = ref('');
// const list=ref([{
//   familyName: "1",
//   id: "28267063881739641",
//   isReceive: false,
//   isSign: false,
//   isrelease: false,
//   merchantCustomerId: null,
//   obituaryImg: "https://image.dqhmbz.com//UploadImg/20240921/6f5e425fe8694530a9a805d366dc0f1b.png",
//   obituarySignature: null,
//   obituaryTitle: "33",
//   releaseDate: "2024-09-21",
//   serviceProfileId: "28267063900204341",
//   shareTotal: 0,
//   userName: "新建讣告",
//   viewTotal: 0
// }])
const refreshing = ref(false);
const list: any = ref([]);
const pageNo = ref(0);
const refresh = ref(false);
const loading = ref(false);
const finished = ref(false);
const router = useRouter();
onMounted(() => {
  document.title = '纪念堂管理';
})
const onRefresh = () => {
  pageNo.value = 0;
  list.value = [];
  refreshing.value = false;
  // 清空列表数据
  finished.value = false;
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true;
  onLoad();
};
const onLoad = () => {
  pageNo.value++;
  personobituaryApi.list(pageNo.value, {
    // "categoryId": chooseTab.value,
    // // "categoryId":0,
    // contentTitle:contentTitle.value
    userName: userName.value
  }).then(res => {
    console.log(res)
    list.value = list.value.concat(res.data.data || []);
    if (list.value.length >= res.data.dataCount) {
      finished.value = true;
    }
  }).finally(() => {
    loading.value = false;
    refresh.value = false;
  })
}
const gotoPage = (path: string) => {
  router.push(path);

}


return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "flex-1",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userName).value = $event)),
          placeholder: "逝者名称"
        }, null, 512), [
          [_vModelText, userName.value]
        ]),
        _createElementVNode("button", {
          class: "search",
          onClick: onRefresh
        }, "搜索")
      ]),
      _createElementVNode("button", {
        class: "add",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (gotoPage('/memorialedit')))
      }, "+")
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"height":"4.5rem"} }, null, -1)),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          onLoad: onLoad,
          class: "list-content"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card",
                key: index
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(item.obituaryTitle) + " ", 1),
                    _createElementVNode("text", _hoisted_5, _toDisplayString(item.releaseDate), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: item.obituaryImg,
                    mode: "widthFix",
                    class: "image"
                  }, null, 8, _hoisted_7),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.userName), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", null, "浏览量：" + _toDisplayString(item.viewTotal), 1),
                      _createElementVNode("div", _hoisted_11, "转发量：" + _toDisplayString(item.shareTotal), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (gotoPage('/memorialedit?id='+item.id))
                      }, "编辑", 8, _hoisted_13),
                      _createElementVNode("button", {
                        class: "btn2",
                        onClick: ($event: any) => (gotoPage('/memorialhall?id='+item.id+'&ismemorial=1'))
                      }, "查看", 8, _hoisted_14)
                    ])
                  ])
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-n fje card-bottom" }, null, -1))
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_tabbar, {
      route: "",
      fixed: "",
      placeholder: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/",
          icon: "apps-o"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("相关讣告")
          ])),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/memoriallist",
          icon: "notes-o"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("纪念堂管理")
          ])),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})